import React, { Component } from "react";
import { Checkbox } from "react-bootstrap";

export default class TypeWordCheckboxItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: true,
      changed: false,
    };
    this.toggle = this.toggle.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.checkedAll !== nextProps.checkedAll) {
      this.setState({ changed: true });
    }
  }
  toggle(e) {
    this.setState({ checked: e.target.checked, changed: false });
  }

  render() {
    return (
      <li>
        <Checkbox
          onChange={this.toggle}
          name={this.props.name}
          checked={
            this.state.changed ? this.props.checkedAll : this.state.checked
          }
          value={this.props.value}
          inline
        >
          {this.props.label}
        </Checkbox>{" "}
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/wordsearchscreens/Forms/TypeWordCheckboxItem.jsx